import React, { Component } from 'react';
import _ from 'lodash';
import { Icon, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';

import ReactTable from 'Common/ReactTableWrapper';
import {
  caseInsensitiveFilter,
  numericSortMethod,
  qtyOnHandSortMethod,
  dateSortMethod,
} from 'Common/GridHelper';
import { FilterEnum, ItemEnum } from 'Common/FieldEnum';
import {BracketTypeEnum} from 'Common/Constants/Enumeration/ManageProcessOrderEnum';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { ToolTipComponent } from 'Components';
import { PACK_SIZE_MESSAGE } from 'Common/Constants/inventory';
import {dollarCalculation, quantityCalculation, weightCalculation} from "Common/FormHelper";

class ItemGridFormFieldContainer extends Component {
  static defaultProps = {
    resetPageOnDataChange: true,
    negativeQtyAllowed: false,
    showCalc: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          Header: () => {
            return (
              <span>
                Item <br />
                Code
              </span>
            );
          },
          visibilityName: 'Item Code',
          accessor: ItemEnum.ItemCode,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Description',
          accessor: ItemEnum.Description,
          ...ReactTableWrapperColumnProperties,
          width: 200,
          Filter: this.filterData,
        },
        {
          Header: 'Kitchen Item',
          accessor: ItemEnum.PrepareInHouse,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: () => {
            return (
              <ToolTipComponent
                label={'Pack Size'}
                popMessage={PACK_SIZE_MESSAGE}
                iconName="question circle outline"
              />
            );
          },
          visibilityName: 'Pack Size',
          accessor: ItemEnum.QtyPerUnit,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Item Packaging',
          accessor: ItemEnum.ItemPackaging,
          ...ReactTableWrapperColumnProperties,
          Filter: this.filterData,
        },
        {
          Header: () => {
            return (
              <span>
                Purchase
                <br />
                Qty
              </span>
            );
          },
          visibilityName: 'Purchase Qty',
          accessor: ItemEnum.PriQty,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          Cell: ({ original }) => {
            return (
              <EditableLabel
                label={
                  original[ItemEnum.PriQty] ? original[ItemEnum.PriQty] : ''
                }
                labelClassName={'qtyLabel'}
                refData={original}
                inputType={'text'}
                onChange={this.handleChangePriQty}
                disabled={props.disabled}
                allowEdit={true}
              />
            );
          },
          Filter: this.filterData,
        },
        {
          Header: 'Unit',
          accessor: ItemEnum.Unit,
          Filter: this.filterData,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: () => {
            return (
              <span>
                Pack <br />
                Qty
              </span>
            );
          },
          visibilityName: 'Pack Qty',
          accessor: ItemEnum.SecQty,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          Cell: ({ original }) => {
            return original.AllowPartialOrdering ? (
              <EditableLabel
                label={
                  original[ItemEnum.SecQty] ? original[ItemEnum.SecQty] : ''
                }
                labelClassName={'qtyLabel'}
                refData={original}
                inputType={'text'}
                onChange={this.handleChangeSecQty}
                disabled={props.disabled}
                allowEdit={true}
                showCalc={this.props.showCalc}
              />
            ) : (
              <div style={{ height: 20 }} />
            );
          },
          Filter: this.filterData,
        },
        {
          Header: 'Pack Unit',
          accessor: ItemEnum.SecondaryUnit,
          Filter: this.filterData,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Price',
          accessor: ItemEnum.PrimaryPrice,
          className: 'right-align',
          Filter: this.filterData,
          Cell: ({ original }) => {
            const { scope } = this.props;
            let price = original[ItemEnum.PrimaryPrice];
            if(original.BracketPricingDetails && original.BracketPricingDetails.length > 0) {
              if (original.BracketType === BracketTypeEnum.Dollars) {
                price = dollarCalculation(
                    original,
                    +original.BracketPricingDetails[0].Price,
                    true
                );
              } else if (original.BracketType === BracketTypeEnum.Quantity) {
                price = quantityCalculation(original, true);
              } else if (original.BracketType === BracketTypeEnum.Weight) {
                price = weightCalculation(original, true);
              }
            }
            return scope ? (
              <SecurityPreferences scope={scope}>
                {disabled => {
                  return (original.PriQty || original.SecQty) && !disabled ? (
                    <EditableLabel
                      label={
                        price
                          ? price
                          : ''
                      }
                      labelClassName={'qtyLabel'}
                      refData={original}
                      onChange={this.handleChangePrimaryPrice}
                      allowEdit={true}
                      onBlur={this.handleOnBlurPrimaryPrice}
                      disabled={props.disabled}
                    />
                  ) : (
                    <span>{Number(price).toFixed(4)}</span>
                  );
                }}
              </SecurityPreferences>
            ) : (
              <span>{Number(price).toFixed(4)}</span>
            );
          },
          ...ReactTableWrapperColumnProperties,
          sortable: !this.props.scope,
          sortMethod: numericSortMethod,
        },
        {
          Header: 'Distributor',
          accessor: ItemEnum.VendorName,
          Filter: this.filterData,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: () => {
            return (
              <span>
                Qty <br />
                On Hand
              </span>
            );
          },
          visibilityName: 'Qty On Hand',
          accessor: ItemEnum.QtyOnHand_Detail,
          Filter: this.filterData,
          sortMethod: qtyOnHandSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Alternate Item',
          accessor: ItemEnum.AlternateItemId,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Account Category',
          accessor: ItemEnum.AccountCategory,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Bid Group',
          accessor: ItemEnum.BidGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Tax Group',
          accessor: ItemEnum.TaxGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Distributor Item',
          accessor: ItemEnum.VendorItem,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Brand',
          accessor: ItemEnum.CurrentBrand,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'UPC',
          accessor: ItemEnum.UPC,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'GTIN',
          accessor: ItemEnum.GTINNumber,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Begin Date',
          accessor: ItemEnum.BeginDate,
          ...ReactTableWrapperColumnProperties,
          show: false,
          sortMethod: dateSortMethod,
          Filter: this.filterData,
        },
        {
          Header: 'End Date',
          accessor: ItemEnum.EndDate,
          ...ReactTableWrapperColumnProperties,
          show: false,
          sortMethod: dateSortMethod,
          Filter: this.filterData,
        },
        {
          Header: 'Servings Per Purchase Unit',
          accessor: ItemEnum.ServingsPerPrimaryUnit,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Menu Costing',
          accessor: ItemEnum.MenuCosting,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Order Preference',
          accessor: ItemEnum.OrderPreference,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Storage Location',
          accessor: ItemEnum.StorageLocation,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Minimum Par Level',
          accessor: ItemEnum.MinimumParLevel,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Maximum Par Level',
          accessor: ItemEnum.MaximumParLevel,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          Header: 'Truck Route',
          accessor: ItemEnum.TruckRoute,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: this.filterData,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            return (original[ItemEnum.SecQty] ||
              original[ItemEnum.SecQty] === 0 ||
              (original[ItemEnum.PriQty] || original[ItemEnum.PriQty] === 0)) &&
              !props.disabled ? (
              <Icon
                name={'minus circle'}
                className={''}
                style={{
                  cursor: 'pointer',
                }}
                onClick={
                  props.disabled
                    ? () => {}
                    : () => {
                        this.handleRemoveItem(original);
                      }
                }
              />
            ) : null;
          },
          Filter: this.filterData,
        },
      ],
      filterValues: {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.VendorId]: 0,
        [FilterEnum.SiteId]: 0,
      },
    };
  }

  handleOnBlurPrimaryPrice = refData => {
    const currentFields = this.props.input.value;
    const newFields = [];
    _.each(currentFields, field => {
      const newFiled = Object.assign({}, field);
      if (refData[ItemEnum.ItemCode] === newFiled[ItemEnum.ItemCode]) {
        if (refData[ItemEnum.PrimaryPrice].trim().length > 0) {
          newFiled[ItemEnum.PrimaryPrice] = Number(
            refData[ItemEnum.PrimaryPrice]
          ).toFixed(4);
        }
      }
      newFields.push(newFiled);
    });
    this.props.input.onChange(newFields);
  };

  handleChangePrimaryPrice = (refData, newValue) => {
    newValue = newValue.match(/\d{0,6}(\.\d{0,4})?/)[0];
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue.ItemCode === refData.ItemCode;
    });
    if (index > -1) {
      formValues[index][ItemEnum.PrimaryPrice] = newValue;
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[ItemEnum.PrimaryPrice] = newValue;
      formValues.push(newFiled);
    }
    this.props.input.onChange(formValues);
  };
  filterData = ({ filter, onChange }) => {
    return (
      <input
        tabIndex="-1"
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
      />
    );
  };

  handleRemoveItem = original => {
    const currentFields = _.cloneDeep(this.props.input.value);
    _.remove(currentFields, item => {
      return original.ItemCode === item.ItemCode;
    });
    this.props.input.onChange(currentFields);
  };

  handleChangeSecQty = (refData, newValue, defaultValue) => {
    this.handleChangeQty(refData, newValue, ItemEnum.SecQty, defaultValue);
  };

  handleChangePriQty = (refData, newValue, defaultValue) => {
    this.handleChangeQty(refData, newValue, ItemEnum.PriQty, defaultValue);
  };

  handleChangeQty = (refData, newValue, Qty, defaultValue) => {
    const { negativeQtyAllowed } = this.props;
    let value = negativeQtyAllowed
      ? newValue.match(/^-?\d{0,6}(\.\d{0,4})?/)[0]
      : newValue.match(/\d{0,6}(\.\d{0,4})?/)[0];
    if (!value && newValue) {
      value = defaultValue;
    }
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue.ItemCode === refData.ItemCode;
    });
    const primOrSecQty =
      Qty === ItemEnum.PriQty ? ItemEnum.SecQty : ItemEnum.PriQty;
    if (index > -1) {
      if (value && value.trim().length) {
        formValues[index][Qty] = value;
      } else if (!refData[primOrSecQty] || !refData[primOrSecQty].toString()) {
        if (this.props.isPreviewPage) {
          formValues[index][Qty] = value;
        } else {
          _.remove(formValues, field => {
            return field.ItemCode === refData.ItemCode;
          });
        }
      } else {
        formValues[index][Qty] = value;
      }
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[Qty] = value;
      if (value.trim().length) {
        formValues.push(newFiled);
      }
    }
    this.props.input.onChange(formValues);
  };
  prepareTableData = () => {
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemEnum.ItemCode]: item[ItemEnum.ItemCode],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][ItemEnum.PriQty] = dataRow[ItemEnum.PriQty];
          dataSourceCopy[index][ItemEnum.SecQty] = dataRow[ItemEnum.SecQty];
          dataSourceCopy[index][ItemEnum.PrimaryPrice] =
            dataRow[ItemEnum.PrimaryPrice];
        }
      });
    }
    return dataSourceCopy;
  };

  getTrProps = (state, rowInfo) => {
    let selected = false;
    if (
      rowInfo &&
      rowInfo.original &&
      (rowInfo.original[ItemEnum.PriQty] || rowInfo.original[ItemEnum.SecQty])
    ) {
      selected = true;
    }
    return {
      style: {
        color: selected && !this.props.disabled ? '#df5a17' : '',
        fontWeight: selected && !this.props.disabled ? '600' : '500',
      },
    };
  };

  render() {
    const {
      fetchingOrderItems,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      tableName,
      resetPageOnDataChange,
      onResetPageOnDataChange,
      gridName,
    } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          loading={
            fetchingOrderItems ||
            gridPreferenceLoading ||
            gridPreferenceSubmitting
          }
          data={this.prepareTableData()}
          reactTableRef={this.reactTable}
          resizable={true}
          defaultFilterMethod={caseInsensitiveFilter}
          noDataText={fetchingOrderItems ? '' : 'No items found'}
          draggableColumns={true}
          showHideColumn={true}
          savePreference={this.onSaveGridPreferenceClick}
          menu={'hasCogs'}
          saveState={{
            tableName,
          }}
          getTrProps={this.getTrProps}
          columns={this.state.columns}
          resetPageOnDataChange={resetPageOnDataChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
          gridName={gridName}
        />
      </Form.Field>
    );
  }
}
const mapStateToProps = state => {
  const { gridPreference } = state.CommonState;

  return {
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
  };
};

export const ItemGridFormField = connect(
  mapStateToProps,
  null
)(ItemGridFormFieldContainer);



// WEBPACK FOOTER //
// ./src/components/itemgridformfield/ItemGridFormField.js